import React, { useEffect, useState } from 'react';

interface Props {
  redirect_url: string;
  user_email: string;
}

export default function DesktopRedirect({ redirect_url, user_email }: Props) {
  const [attempted, setAttempted] = useState(false);

  const openDesktopApp = async () => {
    setAttempted(true);
    console.log('Attempting to open:', redirect_url);

    // Open the desktop app via deep link
    window.location.href = redirect_url;
  };

  useEffect(() => {
    // Try to open automatically after a short delay
    const timer = setTimeout(() => {
      openDesktopApp();
    }, 1500);

    return () => clearTimeout(timer);
  }, [redirect_url]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-500 via-purple-600 to-purple-800">
      <div className="text-center p-8 bg-white/10 rounded-xl backdrop-blur-lg shadow-2xl max-w-md mx-4">
        {/* Loading Spinner */}
        <div className="w-12 h-12 border-4 border-white/30 border-l-white rounded-full animate-spin mx-auto mb-6"></div>

        <h2 className="text-2xl font-bold text-white mb-4">
          Authentication Successful!
        </h2>

        <p className="text-white/90 mb-2">
          Welcome back, {user_email}
        </p>

        <p className="text-white/80 mb-6">
          Opening Race App Desktop...
        </p>

        {/* Manual fallback */}
        <div className="bg-white/10 rounded-lg p-4 mt-6">
          <p className="text-white font-medium mb-3">
            Desktop app not opening?
          </p>

          <button
            onClick={openDesktopApp}
            className="bg-white text-purple-600 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200 w-full mb-3"
          >
            Open Race App Desktop
          </button>

          <p className="text-white/70 text-sm">
            Make sure Race App Desktop is installed and try clicking the button above.
          </p>

          {attempted && (
            <p className="text-white/60 text-xs mt-2">
              Redirect attempted. If nothing happened, the desktop app may not be properly registered.
            </p>
          )}
        </div>

        {/* Debug info for development */}
        {process.env.NODE_ENV === 'development' && (
          <details className="mt-4 text-left">
            <summary className="text-white/70 text-xs cursor-pointer">Debug Info</summary>
            <pre className="text-white/60 text-xs mt-2 p-2 bg-black/20 rounded overflow-x-auto">
              {redirect_url}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
}